import React from 'react'
import { useLottie } from "lottie-react";
import animationData from './No Beneficiary.json';

export default function NoBeneficiaryAnimation() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
      const { View } = useLottie(defaultOptions);
      return (
        <div style={{ width: "120px", height: "120px" }} >
          {View}
        </div>
      );
  }
